import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.mode === 'dark' ? '#3399bf': '#576572',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

  export default function TablaDocs({rows, id=""}) {
    const [t] = useTranslation('global');
    return (
      <TableContainer component={Paper} id={id}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{fontWeight: "bold", textTransform: 'uppercase',verticalAlign: 'top'}} align="left">{t('content.tablaDocDowloand.Descripcion')}</StyledTableCell>
              <StyledTableCell sx={{fontWeight: "bold", textTransform: 'uppercase',width:'20%',verticalAlign: 'top'} } align="left">{t('content.tablaDocDowloand.Detalles')}</StyledTableCell>
              
            </TableRow>
          </TableHead>
          <TableBody>
          {rows.map((row, index) => (
        <StyledTableRow
          key={index}
          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
          <StyledTableCell align="left" sx={{ verticalAlign: 'top' }}>
            {row.Descripcion}
          </StyledTableCell>
          <StyledTableCell align="left" sx={{ verticalAlign: 'top' }}>
            <a href={row.Detalles} download  style={{ color: '#3cacdc ' }}>{t('content.factura.DescargarEjemplo')}</a>
          </StyledTableCell>
        </StyledTableRow>
      ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }